import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { Configuration } from './configuration';


import { ApplicationRolesService } from './api/applicationRoles.service';
import { ApplicationsService } from './api/applications.service';
import { ApplicationSecretsService } from './api/applicationSecrets.service';
import { ApplicationSitesService } from './api/applicationSites.service';
import { ApplicationUsersService } from './api/applicationUsers.service';
import { IdentityProvidersService } from './api/identityProviders.service';
import { ImageBundlesService } from './api/imageBundles.service';
import { ImagesService } from './api/images.service';
import { LookupsService } from './api/lookups.service';
import { ProfileService } from './api/profile.service';
import { ServicesService } from './api/services.service';
import { ServicesSecretsService } from './api/servicesSecrets.service';
import { UserAccessesService } from './api/userAccesses.service';
import { UserAccessLogService } from './api/userAccessLog.service';
import { UserApplicationsService } from './api/userApplications.service';
import { UsersService } from './api/users.service';
import { VendorIntegrationsService } from './api/vendorIntegrations.service';

@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [],
  exports:      [],
  providers: [
    ApplicationRolesService,
    ApplicationSecretsService,
    ApplicationSitesService,
    ApplicationUsersService,
    ApplicationsService,
    IdentityProvidersService,
    ImageBundlesService,
    ImagesService,
    LookupsService,
    ProfileService,
    ServicesService,
    ServicesSecretsService,
    UserAccessLogService,
    UserAccessesService,
    UserApplicationsService,
    UsersService,
    VendorIntegrationsService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule) {
      if (parentModule) {
          throw new Error('ApiModule is already loaded. Import your base AppModule only.');
      }
    }

    /*
    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
    */
}



// WEBPACK FOOTER //
// /ng-app/src/apiModule/api.module.ts